import { FormState } from 'src/types';

export const getHelpTextIcon = (state: FormState) => {
  switch (state) {
    case FormState.SUCCESS:
      return 'check-circle';
    case FormState.ERROR:
      return 'exclamation-octagon';
    case FormState.WARNING:
      return 'exclamation-triangle';
    default:
      return '';
  }
};
